import { VApp } from 'vuetify/lib/components/VApp';
import { VContent } from 'vuetify/lib/components/VContent';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{staticClass:"yc-application"},[_c('div',{staticClass:"full-height"},[_c(VContent,{staticClass:"full-height"},[_c('div',{staticClass:"body-container"},[_c('div',{staticClass:"yc-body-main-wrapper"},[_c('router-view')],1)])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }